import React from 'react'
import UploadArea from 'components/UploadArea'

export default class TabContentPersonal extends React.Component {
  render() {
    const { photoList } = this.props

    return (
      <>
        <div className='modal__upload'>
          <UploadArea
            photoList={photoList}
            changeUploadPhoto={this.props.changeUploadPhoto}
            changeDeletedPhoto={this.props.changeDeletedPhoto}
          />
        </div>

        <div className='modal__photo-desc'>
          <p>Требования к фото:</p>
          <p>— Нейтральный фон</p>
          <p>— Вгляд направленный на камеру</p>
          <p>— Лицо ровно перпендикулярно к камере</p>
          <p>— Нейтральное выражение лица</p>
          <p>— Отсутствие аксессуаров на лице (очки, каска, маска и т.п)</p>
          <p>— В кадре должно быть только одно лицо</p>
          <p>— Формат файла - JPEG</p>
          <p>— Минимальный размер фото — 300х300рх</p>
          <br />
          <span>
            Рекомендация: загрузите несколько фотографий для лучшего
            распознавания
          </span>
        </div>
      </>
    )
  }
}
